import { asArray } from './format.js';

export function getListingTitle(listing) {
  return String(listing?.title || listing?.titleEn || listing?.name || '').trim();
}

export function getListingBullets(listing) {
  const bullets = asArray(listing?.bullets || listing?.bulletPoints || listing?.metadata?.listingDraftBullets?.bulletsEn);
  return bullets
    .map((item) => (typeof item === 'string' ? item : (item?.bulletEn || item?.text || '')))
    .map((item) => String(item || '').trim())
    .filter(Boolean);
}

export function buildPromptFromListing(listing) {
  const title = getListingTitle(listing);
  const bullets = getListingBullets(listing).slice(0, 3).join('; ');
  const parts = [
    'Amazon product showcase video',
    'clean ecommerce background',
    'slow camera push-in',
    'natural product motion',
  ];
  if (title) parts.push(`product: ${title}`);
  if (bullets) parts.push(`highlight: ${bullets}`);
  return parts.join(', ').slice(0, 2000);
}

export function getListingsFromResponse(resp) {
  if (Array.isArray(resp)) return resp;
  if (Array.isArray(resp?.listings)) return resp.listings;
  if (Array.isArray(resp?.items)) return resp.items;
  if (Array.isArray(resp?.data)) return resp.data;
  return [];
}
